import { StaticProps } from '../../context';
import { createSchema } from '~/lib/useQueryParameter';
import { programLevelsFilter } from './programLevelsFilter';
import { searchQueryFilter } from './searchQueryFilter';
import { pageNumberParameter } from './pageNumberParameter';
import { pageSizeParameter } from './pageSizeParameter';
import { fieldsOfStudyFilter } from './fieldsOfStudyFilter';
import { sortParameter } from './sortParameter';
import { ProgramsSearchQuery } from '../../data/usePrograms';

export type Parameters = {
  searchQuery: string | undefined;
  programLevels: string[];
  fieldsOfStudy: string[];
  pageSize: number;
  pageNumber: number;
  sort: string | undefined;
};

export const schema = createSchema<StaticProps, ProgramsSearchQuery, Parameters>({
  fieldsOfStudy: fieldsOfStudyFilter,
  programLevels: programLevelsFilter,
  pageSize: pageSizeParameter,
  pageNumber: pageNumberParameter,
  searchQuery: searchQueryFilter,
  sort: sortParameter,
});
